import type { PinV1 } from './PinV1'
import type { GranularityUnit } from '~/state/useGranularityState'

/** The unit a pin REPLAYS and EXPORTS at (spec §3.3). New pins carry the display unit they
 *  were created at; legacy pins (no render_unit) replay at their frozen wire bucket —
 *  deterministic, and the URL never participates. The final 'month' mirrors the replay arms'
 *  long-standing `bucket_size ?? 'month'` default (ChartFromPin/fetchPinData). Type note:
 *  render_unit's literals are exactly GranularityUnit's; type-only import, no runtime state
 *  coupling (same pattern as dataPipeline.ts). */
export function replayUnitOf(pin: PinV1): GranularityUnit {
  return pin.render_hint.render_unit ?? pin.walk_call.params.bucket_size ?? 'month'
}
